module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAG1BMVEUAAAAzMzMyMjIyMjIzMzMzMzMzMzMzMzMyMjJkUDCsAAAACXRSTlMAS1Hf4OHx8vORdtEfAAAAO0lEQVQIHQXBMRGAUAwFsJSD/U09RsY/IgULlYAEnJMAHKEeNXTo1KCmA/2CNbB9HazUsH2clz3UDfgB2v8FUiDfkDsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-close.png
// module id = 8FE4
// module chunks = 0